<script lang="ts">
    import KpGenericTable from './KpGenericTable.svelte';
    export let bordered = false;
    export let hoverRows = false;
    export let stripedRows = false;
    export let condensed = false;
</script>

<template>
    <div class="table-responsive">
        <KpGenericTable {bordered} {hoverRows} {stripedRows} {condensed}>
            <slot name="header" slot="header"></slot>
            <slot name="body" slot="body"></slot>
            <slot name="footer" slot="footer"></slot>
        </KpGenericTable>
    </div>
</template>